import { render, staticRenderFns } from "./table-list.vue?vue&type=template&id=0981bd68&scoped=true"
import script from "./table-list.vue?vue&type=script&lang=js"
export * from "./table-list.vue?vue&type=script&lang=js"
import style0 from "./table-list.vue?vue&type=style&index=0&id=0981bd68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0981bd68",
  null
  
)

export default component.exports